import { useState } from "react";

export const useInput = (validationFn: (value: string) => boolean) => {

  const [inputValue, setInputValue] = useState('');
  const [inputIsTouched, setInputIsTouched] = useState(false);

  const valueIsValid = validationFn(inputValue);

  const onInputChange = (value: string) => {
    setInputValue(value);
  };

  const onInputBlur = () => {
    setInputIsTouched(true);
  };

  const resetInput = () => {
    setInputValue('');
  };

  return {
    inputValue,
    hasError: inputIsTouched && !valueIsValid,
    onInputChange,
    onInputBlur,
    resetInput,
  };
};
